const state = {
  buttonId: "",
  version: "0.0.0",
  refData: {}
}

const actions = {
  SET_VERSION({commit}, data) {
    commit('SET_VERSION', data);
  }
}
const mutations = {
  SET_BUTTON(state, data) {
    state.buttonId = data;
  },
  SET_VERSION(state, data) {
    state.version = data;
  },
  SET_REF_DATA(state, data){
    state.refData = {...data};
  }
}

const getters = {
  getButtonId(state) {
    return state.buttonId;
  },
  getVersion(state) {
    return state.version;
  },
  getRefData(state){
    return state.refData;
  },
  getCurrentCohortYear(state){
    return (state.refData.currentCohortYear && state.refData.currentCohortYear.ece) || null;
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
